import { NgIf } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { OptInOutModel } from '../../models/optInOut.model';

@Component({
  selector: 'app-enabling-new-channel-modal',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, NgIf],
  templateUrl: './enabling-new-channel-modal.component.html',
  styleUrl: './enabling-new-channel-modal.component.scss'
})
export class EnablingNewChannelModalComponent {

  readonly dialogRef = inject(MatDialogRef<EnablingNewChannelModalComponent>);
 
  constructor(
    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  getChannelIcon(channel: string): string {
    
    switch (channel.toUpperCase()) {
      case 'SMS': return 'sms';
      case 'CALL': return 'call';
      case 'MAIL': return 'alternate_email';
      default: return 'help';
    }
  }

  close() {
    this.dialogRef.close();
  }

  enableConsent(channel: string, value: string, option: string){

    // create an array of observables for each changed item

    const optInOut: OptInOutModel = {
      actionId: option == 'optout' ? 2 : 1,
      appId: 12,
      byCustomer: false,
      customerAppId: 'N/A',
      subApp: null, 
      values: [{
        channels: [this.getChannelId(channel)],
        value: value
      }],
      windowsUser: ''
    };


    this.dialogRef.close(optInOut)

  }

   getChannelId(channelName: string): number {
    
    switch (channelName.toUpperCase()) {
      case 'SMS':
        return 1;
      case 'CALL':
        return 2;
      case 'MAIL':
        return 3;
      default:
        return 0
    }
  }
 
}
